import { call, put, takeLatest } from 'redux-saga/effects';
import { types, urls } from './index';
import { apiPost } from 'src/utils/api';
import notify from 'src/utils/notify';

function* authenticate(action) {
    try {
        const response = yield call(apiPost, {
            path: urls.SIGN_IN,
            payload: action.payload
        });
        if (response.error) {
            yield put({
                type: types.SIGN_IN_FAILURE,
                payload: response,
            });
            notify.error(response.error);
        } else {
            yield put({
                type: types.SIGN_IN_SUCCESS,
                payload: response.data,
            });
        }
    } catch (error) {
        yield put({
            type: types.SIGN_IN_FAILURE,
            payload: error,
        });
        notify.error(error.message);
    }
}

function* register(action) {
    try {
        const response = yield call(apiPost, {
            path: urls.SIGN_UP,
            payload: action.payload
        });
        if (response.error) {
            yield put({
                type: types.SIGN_UP_FAILURE,
                payload: response,
            });
            notify.error(response.error);
        } else {
            yield put({
                type: types.SIGN_UP_SUCCESS,
                payload: response.data,
            });
        }
    } catch (error) {
        yield put({
            type: types.SIGN_UP_FAILURE,
            payload: error,
        });
        notify.error(error.message);
    }
}

function* activate(action) {
    try {
        const response = yield call(apiPost, {
            path: urls.ACTIVATE,
            payload: action.payload
        });
        if (response.error) {
            yield put({
                type: types.ACTIVATE_FAILURE,
                payload: response,
            });
            notify.error(response.error);
        } else {
            yield put({
                type: types.ACTIVATE_SUCCESS,
                payload: response,
            });
        }
    } catch (error) {
        yield put({
            type: types.ACTIVATE_FAILURE,
            payload: error,
        });
        notify.error(error.message);
    }
}

function* signOut() {
    yield put({
        type: types.SIGN_OUT_SUCCESS,
    });
}
export default function* authWatcher() {
    yield takeLatest(types.SIGN_IN_REQUEST, authenticate);
    yield takeLatest(types.SIGN_UP_REQUEST, register);
    yield takeLatest(types.ACTIVATE_REQUEST, activate);
    yield takeLatest(types.SIGN_OUT_REQUEST, signOut);
}
